/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";


import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../redux/language/selector";
import NavbarTop from "../components/global/NavbarTop";
import NotFoundContent from "../components/NotFound/NotFoundContent";


const Home = () => {
    const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    useEffect(() => {
        document.title = t('home-page.home-title')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[language])
    return (
        
        <div>
            <NavbarTop/>
            <NotFoundContent/>
        </div>
    )
}

export default Home